import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { RedactionService } from 'src/app/_services/redaction.service';
import { ERPortServiceService } from 'src/app/_services/erport-service.service';


@Component({
  selector: 'app-redaction',
  templateUrl: './redaction.component.html',
  styleUrls: ['./redaction.component.scss']
})
export class RedactionComponent implements OnInit {

  //Extraction Closing elements
  @ViewChild('closeAddGroupExtractionForm') closeAddGroupExtractionForm: ElementRef;
  @ViewChild('closeShareEmailExtraction') closeShareEmailExtraction: ElementRef;
  @ViewChild('closeAddTermExtraction') closeAddTermExtraction: ElementRef;
  @ViewChild('closeDeleteConfirmationExtraction') closeDeleteConfirmationExtraction: ElementRef;

  //Redaction Closing elements
  @ViewChild('closeAddGroupRedactionForm') closeAddGroupRedactionForm: ElementRef;
  @ViewChild('closeShareEmailRedaction') closeShareEmailRedaction: ElementRef;
  @ViewChild('closeAddTermRedaction') closeAddTermRedaction: ElementRef;
  @ViewChild('closeDeleteConfirmationRedaction') closeDeleteConfirmationRedaction: ElementRef;
  
  
  addExtractionGroupForm: FormGroup;
  addRedactionGroupForm: FormGroup;

  userEmail: string;
  erUrl: any;
  headerOptions = {
    showHeading: false,
    showSearch: false,
    heading: "",
    data: undefined,
  };
  selectedType: string = localStorage.getItem('selectedTabType') || 'Extraction';
  groupDetails: any;

  extractionTerms: any;
  redactionTerms: any;

  extractionTermsCopy: any;
  redactionTermsCopy: any;

  searchExtraction: any;
  selectedExtractionGroup: any;
  newExtractionTerm: string = '';
  extractionShareUser: string = '';
  selectedExtractionGroupIndex: any;
  selectedExtractionTermIndex: any;
  selectedExtractionTermTitle: string;
  extractionGroupSearch: string = '';
  editExtractionGroupName: string = '';
  editExtractionGroupInfo: string = '';

  searchRedaction: any;
  selectedRedactionGroup: any;
  newRedactionTerm: string = '';
  redactionShareUser: string = '';
  selectedRedactionGroupIndex: any;
  selectedRedactionTermIndex: any;
  selectedRedactionTermTitle: string;
  redactionGroupSearch: string = '';
  editRedactionGroupName: string = '';
  editRedactionGroupInfo: string = '';


  constructor(private readonly toastrService: ToastrService,
    private readonly redactionService: RedactionService,
    private readonly formBuilder: FormBuilder,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly portDiscovery: ERPortServiceService) { }

  ngOnInit() {
    // this.portDiscovery.getBaseUrl().subscribe(baseUrl => {
    //   console.log('Base URL:', baseUrl);
    //   this.erUrl = baseUrl;
    // });

    this.erUrl = 'http://localhost:8006';

    // this.route.queryParams.subscribe(params => {
    //   this.selectedType = params['type'] == 'extract' ? "Extraction" : "Redaction";
    //   this.headerOptions["heading"] = ` ${this.selectedType} Settings`;
    // });
    
    this.getRedactionDetails();
    this.initAllForms();
  }

  initAllForms() {
    this.addExtractionGroupForm = this.formBuilder.group({
      title: ['', Validators.required],
      access: ['private', Validators.required]
    });
    this.addRedactionGroupForm = this.formBuilder.group({
      title: ['', Validators.required],
      access: ['private', Validators.required]
    });
  }

  setSelectedType(type: string) {
    this.selectedType = type;
    localStorage.setItem('selectedTabType', type);
  }

  getRedactionDetails()
  {
    this.userEmail = JSON.parse(localStorage.getItem('currentUser')).email;
    this.redactionService.getRedactionFilters(this.erUrl, this.userEmail).subscribe((res)=>
    {
      this.groupDetails = res;

      let extractionDetails = res['data']['Extraction'];
      let redactionDetails =  res['data']['Redaction'];

      let extractionGroups: any = [];
      let redactionGroups: any = [];

      let extractionPII = 
      {
        title: 'Personal Identifable Information',
        access: 'public',
        Entities: extractionDetails['Standard PII'],
        shared: []
      }
      extractionGroups.push(extractionPII);
      extractionDetails['Groups'].forEach(group => {
        let obj = 
        {
          title: group.title,
          access: group.Access,
          Entities: group.Entities,
          shared: group.Shared
        }
        extractionGroups.push(obj);
      });

      let redactionPII = 
      {
        title: 'Personal Identifable Information',
        access: 'public',
        Entities: redactionDetails['Standard PII'],
        shared: []
      }
      redactionGroups.push(redactionPII);
      redactionDetails['Groups'].forEach(group => {
        let obj = 
        {
          title: group.title,
          access: group.Access,
          Entities: group.Entities,
          shared: group.Shared
        }
        redactionGroups.push(obj);
      });



      this.extractionTerms = extractionGroups;
      this.extractionTermsCopy = extractionGroups;
      this.redactionTerms = redactionGroups;
      this.redactionTermsCopy = extractionGroups;

      console.log("working..,", this.extractionTerms, this.redactionTerms);

    })
  }

  saveFilters()
  {
    this.userEmail = JSON.parse(localStorage.getItem('currentUser')).email;
    this.redactionService.saveRedactionFilters(this.erUrl, this.groupDetails).subscribe((res)=>
    {
      this.toastrService.clear();
      this.toastrService.success("Group data updated ");
      this.getRedactionDetails()
    });
  }

  checkShared(groupName : string,er : string)
  {
    this.userEmail = JSON.parse(localStorage.getItem('currentUser')).email;
    this.redactionService.checkSharedGroup(this.erUrl, this.userEmail,groupName,er).subscribe((res)=>
    {
      this.toastrService.clear();
      this.toastrService.success("Group data updated ");
      this.getRedactionDetails()
    });
  }

  
  addExtractionGroup()
  {
    if(this.addExtractionGroupForm.value.title.trim().length == 0)
    {
      this.toastrService.clear();
      this.toastrService.warning("Please the group name and try again ");
      return;
    }

    if (this.extractionTerms.some(item => item.title.toLowerCase() === this.addExtractionGroupForm.value.title.toLowerCase())) {
    this.toastrService.clear();
    this.toastrService.warning("Group name already exist, try with a different name ");
    return;
    }

    let obj = { 
      title: this.addExtractionGroupForm.value.title.trim(),
      Access: this.addExtractionGroupForm.value.access,
      Entities: [],
      Shared: []
    }
    this.groupDetails['data']['Extraction']['Groups'].push(obj);
    this.saveFilters();
    this.closeAddGroupExtractionForm.nativeElement.click();
  }

  addExtractionTerm() {
  let duplicateCheck = false;

  this.extractionTerms.forEach(element => {
    if(element.title == this.selectedExtractionGroup.title) {
      element.Entities.forEach(term => {
        if(term.title == this.newExtractionTerm) {
          duplicateCheck = true;
        }
      });
    }
  });

  if(duplicateCheck) {
    this.toastrService.clear();
    this.toastrService.warning("Term title already added, please try with different name");
    return;
  }

  // Add checked property initialized to false for new terms
  this.selectedExtractionGroup.Entities.push({
    title: this.newExtractionTerm, 
    checked: false
  });

  this.newExtractionTerm = '';
}

  editExtractionTerm(index, title)
  {
    this.selectedExtractionTermIndex =  index;
    this.selectedExtractionTermTitle =  title;
    console.log("Edit term : ", this.selectedExtractionTermIndex);
  }

  saveExtractionTerm()
  {
    this.selectedExtractionGroup.Entities.forEach((element, i) => {
      if(i == this.selectedExtractionTermIndex)
      {
        element['title'] = this.selectedExtractionTermTitle;
        this.selectedExtractionTermIndex = undefined;
      }
    });
  }

  removeExtractionTerm(index)
  {
    this.selectedExtractionGroup.Entities.splice(index, 1)
  }

  saveExtractionGroupDetails() {
    this.groupDetails['data']['Extraction']['Groups'].forEach(element => {
      if(element.title == this.selectedExtractionGroup.title) {
        // Save both the entities and their checked status
        element.Entities = this.selectedExtractionGroup.Entities.map(entity => ({
          title: entity.title,
          checked: entity.checked
        }));
      }
    });
  
    this.saveFilters();
    this.closeAddTermExtraction.nativeElement.click();
  }

  saveExtractionEmailDetails()
  {
    this.groupDetails['data']['Extraction']['Groups'].forEach(element => {
      if(element.title == this.selectedExtractionGroup.title)
      {
        element['Shared'] = this.selectedExtractionGroup.shared;
      }
    });

    this.saveFilters();
    this.closeShareEmailExtraction.nativeElement.click();
  }

  shareExtractionGroup()
  {

    let duplicateCheck = false;

    this.extractionTerms.forEach(element => {
      if(element.title == this.selectedExtractionGroup.title)
      {
        element.shared.forEach(user => {
            if(user.UserName == this.extractionShareUser)
            {
              duplicateCheck = true;
            }
        });
      }
    });

    if(duplicateCheck)
    {
      this.toastrService.clear();
      this.toastrService.warning("Email already added, please try with different mail");
      return;
    }

   this.selectedExtractionGroup.shared.push({UserName : this.extractionShareUser});

   this.extractionShareUser = '';
  }

  removeExtractionUser(index)
  {
    this.selectedExtractionGroup.shared.splice(index, 1);
  }

  editExtractionGroup(index, group)
  {

    this.groupDetails['data']['Extraction']['Groups'].forEach((element, i) => {
      if(index-1 == i)
      {
        element.title = this.editExtractionGroupName;
        element.Access = this.editExtractionGroupInfo;
        this.selectedExtractionGroupIndex = undefined;
      }
    });
    this.saveFilters();
  }

  removeExtractionGroup()
  {
    let updatedList = this.groupDetails['data']['Extraction']['Groups'].filter(element => element.title !== this.selectedExtractionGroup.title);
    this.groupDetails['data']['Extraction']['Groups'] =  updatedList;
    this.checkShared(this.selectedExtractionGroup.title,"Extraction");
    this.saveFilters();
    this.closeDeleteConfirmationExtraction.nativeElement.click();
  }

  filterExtractionGroup()
  {
    let groupCopy = JSON.parse(JSON.stringify(this.extractionTermsCopy));
    if(groupCopy.length == 0)
    {
      return;
    }
   this.extractionTerms =  groupCopy.filter(user => {
        let emailId =  user.title.toLowerCase();
        if(emailId.includes(this.extractionGroupSearch.toLowerCase()))
        {
          return true;
        }
    });

    console.log("after filtering : ", this.extractionTerms)
  }

  addRedactionGroup()
  {
    if(this.addRedactionGroupForm.value.title.trim().length == 0)
    {
      this.toastrService.clear();
      this.toastrService.warning("Please the group name and try again ");
      return;
    }

    if (this.redactionTerms.some(item => item.title.toLowerCase() === this.addRedactionGroupForm.value.title.toLowerCase())) {
    this.toastrService.clear();
    this.toastrService.warning("Group name already exist, try with a different name ");
    return;
    }

    let obj = { 
      title: this.addRedactionGroupForm.value.title.trim(),
      Access: this.addRedactionGroupForm.value.access,
      Entities: [],
      Shared: []
    }
    this.groupDetails['data']['Redaction']['Groups'].push(obj);
    this.saveFilters();
    this.closeAddGroupRedactionForm.nativeElement.click();
  }

  addRedactionTerm() {
    let duplicateCheck = false;
  
    this.redactionTerms.forEach(element => {
      if(element.title == this.selectedRedactionGroup.title) {
        element.Entities.forEach(term => {
          if(term.title == this.newRedactionTerm) {
            duplicateCheck = true;
          }
        });
      }
    });
  
    if(duplicateCheck) {
      this.toastrService.clear();
      this.toastrService.warning("Term title already added, please try with different name");
      return;
    }
  
    // Add checked property initialized to false for new terms
    this.selectedRedactionGroup.Entities.push({
      title: this.newRedactionTerm, 
      checked: false
    });
  
    this.newRedactionTerm = '';
  }

  editRedactionTerm(index, title)
  {
    this.selectedRedactionTermIndex =  index;
    this.selectedRedactionTermTitle =  title;
    console.log("Edit term : ", this.selectedRedactionTermIndex);
  }

  saveRedactionTerm()
  {
    this.selectedRedactionGroup.Entities.forEach((element, i) => {
      if(i == this.selectedRedactionTermIndex)
      {
        element['title'] = this.selectedRedactionTermTitle;
        this.selectedRedactionTermIndex = undefined;
      }
    });
  }

  removeRedactionTerm(index)
  {
    this.selectedRedactionGroup.Entities.splice(index, 1)
  }

  
saveRedactionGroupDetails() {
  this.groupDetails['data']['Redaction']['Groups'].forEach(element => {
    if(element.title == this.selectedRedactionGroup.title) {
      // Save both the entities and their checked status
      element.Entities = this.selectedRedactionGroup.Entities.map(entity => ({
        title: entity.title,
        checked: entity.checked
      }));
    }
  });

  this.saveFilters();
  this.closeAddTermRedaction.nativeElement.click();
}

  saveRedactionEmailDetails()
  {
    this.groupDetails['data']['Redaction']['Groups'].forEach(element => {
      if(element.title == this.selectedRedactionGroup.title)
      {
        element['Shared'] = this.selectedRedactionGroup.shared;
      }
    });

    this.saveFilters();
    this.closeShareEmailRedaction.nativeElement.click();
  }

  shareRedactionGroup()
  {

    let duplicateCheck = false;

    this.redactionTerms.forEach(element => {
      if(element.title == this.selectedRedactionGroup.title)
      {
        element.shared.forEach(user => {
            if(user.UserName == this.redactionShareUser)
            {
              duplicateCheck = true;
            }
        });
      }
    });

    if(duplicateCheck)
    {
      this.toastrService.clear();
      this.toastrService.warning("Email already added, please try with different mail");
      return;
    }

   this.selectedRedactionGroup.shared.push({UserName : this.redactionShareUser});

   this.redactionShareUser = '';
  }

  removeRedactionUser(index)
  {
    this.selectedRedactionGroup.shared.splice(index, 1);
  }

  editRedactionGroup(index, group)
  {

    this.groupDetails['data']['Redaction']['Groups'].forEach((element, i) => {
      if(index-1 == i)
      {
        element.title = this.editRedactionGroupName;
        element.Access = this.editRedactionGroupInfo;
        this.selectedRedactionGroupIndex = undefined;
      }
    });
    this.saveFilters();
  }

  removeRedactionGroup()
  {
    let updatedList = this.groupDetails['data']['Redaction']['Groups'].filter(element => element.title !== this.selectedRedactionGroup.title);
    this.groupDetails['data']['Redaction']['Groups'] =  updatedList;
    this.checkShared(this.selectedRedactionGroup.title,"Redaction");
    this.saveFilters();
    this.closeDeleteConfirmationRedaction.nativeElement.click();
  }

  filterRedactionGroup()
  {
    let groupCopy = JSON.parse(JSON.stringify(this.redactionTermsCopy));
    if(groupCopy.length == 0)
    {
      return;
    }
   this.redactionTerms =  groupCopy.filter(user => {
        let emailId =  user.title.toLowerCase();
        if(emailId.includes(this.redactionGroupSearch.toLowerCase()))
        {
          return true;
        }
    });

    console.log("after filtering : ", this.redactionTerms)
  }

}
